import { isSameDay } from 'date-fns';
import type { SendbirdMessage } from '@sendbird/uikit-utils';
import { MINUTE_MS } from '../constants';

const withCreatedAt = (message: SendbirdMessage, createdAt: number): SendbirdMessage =>
    Object.create(message, { createdAt: { value: createdAt } });

const shiftedWithinDay = (message: SendbirdMessage): number => {
    const before = message.createdAt - MINUTE_MS;
    return isSameDay(before, message.createdAt) ? before : message.createdAt + MINUTE_MS;
};

export const adaptPrevMessageForNameGrouping = (
    message: SendbirdMessage,
    prevMessage?: SendbirdMessage,
): SendbirdMessage => {
    if (!prevMessage) {
        return Object.create(message, {
            createdAt: { value: shiftedWithinDay(message) },
            sender: { value: undefined },
        });
    }
    if (isSameDay(message.createdAt, prevMessage.createdAt)) {
        return withCreatedAt(prevMessage, message.createdAt);
    }
    return withCreatedAt(prevMessage, shiftedWithinDay(message));
};
